export const textToTextNumberModifier = (inputVal = '', precision?: number, maxAmount?: string | number) => {

    inputVal = inputVal + '';

    if (inputVal === '') {
        return '';
    }
    // Replace commas with dots, allow negative sign at the beginning, remove non-numeric characters except dot
    inputVal = inputVal.replace(/,/g, '.').replace(/[^\d.]/g, '');


    // Add a leading zero if dot is the first character
    if (inputVal.startsWith('.')) {
        inputVal = '0' + inputVal;
    }

    // Remove leading zero if followed by a non-dot character, taking care not to remove the minus sign
    inputVal = inputVal.replace(/^(-?)0(\d)/, '$1$2');

    // Limit the number of digits after the decimal to the specified precision
    const split = inputVal.split('.');

    if (split.length > 1) {
        if (Number(precision) >= 0) {
            split[1] = split[1].substring(0, precision);
        }
        inputVal = split[0] + '.' + split[1];
    }

    // Update the value and check against 'maxAmount' if needed
    if (Number(inputVal) > Number(maxAmount)) {
        inputVal = String(maxAmount);
    }

    return inputVal;
}

export const textToTextNumberModifierWithNegative = (inputVal = '', precision?: number, maxAmount?: string | number) => {

    inputVal = inputVal + '';

    if (inputVal === '') {
        return '';
    }
    // Replace commas with dots, allow negative sign at the beginning, remove non-numeric characters except dot
    inputVal = inputVal.replace(/,/g, '.').replace(/^-?/, '$&').replace(/[^-?\d.]/g, '');

    // Add a leading zero if dot is the first character
    if (inputVal.startsWith('.')) {
        inputVal = '0' + inputVal;
    }

    // Ensure that the minus sign is only at the beginning and not duplicated
    inputVal = inputVal.replace(/-(.*)-/, '-$1');

    // Remove leading zero if followed by a non-dot character, taking care not to remove the minus sign
    inputVal = inputVal.replace(/^(-?)0(\d)/, '$1$2');

    // Limit the number of digits after the decimal to the specified precision
    const split = inputVal.split('.');

    if (split.length > 1) {
        if (Number(precision) >= 0) {
            split[1] = split[1].substring(0, precision);
        }
        inputVal = split[0] + '.' + split[1];
    }

    // Update the value and check against 'maxAmount' if needed
    if (Number(inputVal) > Number(maxAmount)) {
        inputVal = String(maxAmount);
    }

    return inputVal;
}
